import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../atoms/icons';
import styles from './Spinner.scss';

const Spinner = function Spinner({ size, color }) {
    return (
        <div className={styles.spinner}>
            <Icon size={size} color={color}>
                <i className="fa fa-spinner" aria-hidden="true" />
            </Icon>
        </div>
    );
};

export default Spinner;

Spinner.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
};

Spinner.defaultProps = {
    size: 36,
    color: 'initial',
};
